var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/scopes/scopes.ts
var config = {
  General: {
    Leads: {
      BRAND: "General.Leads.BRAND" /* BRAND */,
      CREATE: "General.Leads.CREATE" /* CREATE */,
      DELETE: "General.Leads.DELETE" /* DELETE */,
      LEAD_SOURCE_FILTER: "General.Leads.LEAD_SOURCE_FILTER" /* LEAD_SOURCE_FILTER */,
      NOTES: "General.Leads.NOTES" /* NOTES */,
      REASSIGN: "General.Leads.REASSIGN" /* REASSIGN */,
      SUPER: "General.Leads.SUPER" /* SUPER */,
      UPDATE: "General.Leads.UPDATE" /* UPDATE */,
      VIEW: "General.Leads.VIEW" /* VIEW */,
      VIEW_HIDDEN: "General.Leads.VIEW_HIDDEN" /* VIEW_HIDDEN */,
      WARM_TRANSFER: "General.Leads.WARM_TRANSFER" /* WARM_TRANSFER */,
      STAGE_CHANGE: "General.Leads.STAGE_CHANGE" /* STAGE_CHANGE */,
      LEAD_ASSIST: "General.Leads.LEAD_ASSIST" /* LEAD_ASSIST */,
      ONLY_PRIMARY_GROUP: "General.Leads.ONLY_PRIMARY_GROUP" /* ONLY_PRIMARY_GROUP */,
      RESTRICTED_LEAD_SOURCE_ACCESS: "General.Leads.RESTRICTED_LEAD_SOURCE_ACCESS" /* RESTRICTED_LEAD_SOURCE_ACCESS */,
      HIDE_OWNER_INFO: "General.Leads.HIDE_OWNER_INFO" /* HIDE_OWNER_INFO */,
      BRAND_OWNERSHIP: "General.Leads.BRAND_OWNERSHIP" /* BRAND_OWNERSHIP */
    },
    Scorecard: {
      ACCESS: "General.Scorecard.ACCESS" /* ACCESS */,
      VIEW_TEAM: "General.Scorecard.VIEW_TEAM" /* VIEW_TEAM */,
      VIEW_ALL: "General.Scorecard.VIEW_ALL" /* VIEW_ALL */,
      LEADERBOARD: "General.Scorecard.LEADERBOARD" /* LEADERBOARD */
    }
  },
  Global: {
    Settings: {
      ACCESS: "General.Settings.ACCESS" /* ACCESS */
    }
  },
  Management: {
    Tasks: {
      SUPER: "Management.Tasks.SUPER" /* SUPER */,
      BRAND: "Management.Tasks.BRAND" /* BRAND */,
      VIEW: "Management.Tasks.VIEW" /* VIEW */
    },
    Roles: {
      CREATE: "Management.Roles.CREATE" /* CREATE */,
      UPDATE: "Management.Roles.UPDATE" /* UPDATE */,
      DELETE: "Management.Roles.DELETE" /* DELETE */,
      LIST: "Management.Roles.LIST" /* LIST */,
      IS_BRAND_ADMIN: "Management.Roles.IS_BRAND_ADMIN" /* IS_BRAND_ADMIN */,
      IS_SUPER_ADMIN: "Management.Roles.IS_SUPER_ADMIN" /* IS_SUPER_ADMIN */
    },
    Campaigns: {
      VIEW: "Management.Campaigns.VIEW" /* VIEW */,
      CREATE_ASSIGNMENT: "Management.Campaigns.CREATE_ASSIGNMENT" /* CREATE_ASSIGNMENT */,
      UPDATE_ASSIGNMENT: "Management.Campaigns.UPDATE_ASSIGNMENT" /* UPDATE_ASSIGNMENT */,
      ASSIGNED: "Management.Campaigns.ASSIGNED" /* ASSIGNED */,
      DELETE_ASSIGNED: "Management.Campaigns.DELETE_ASSIGNED" /* DELETE_ASSIGNED */,
      ALL: "Management.Campaigns.ALL" /* ALL */,
      BRAND: "Management.Campaigns.BRAND" /* BRAND */,
      SUPER: "Management.Campaigns.SUPER" /* SUPER */
    },
    Brands: {
      CREATE: "Management.Brands.CREATE" /* CREATE */,
      DELETE: "Management.Brands.DELETE" /* DELETE */,
      UPDATE: "Management.Brands.UPDATE" /* UPDATE */,
      VIEW: "Management.Brands.VIEW" /* VIEW */,
      ZOHO_SYNC: "Management.Brands.ZOHO_SYNC" /* ZOHO_SYNC */,
      ALL: "Management.Brands.ALL" /* ALL */,
      LOCATION_ADD: "Management.Brands.LOCATION_ADD" /* LOCATION_ADD */,
      LOCATION_REMOVE: "Management.Brands.LOCATION_REMOVE" /* LOCATION_REMOVE */,
      LOCATION_ASSIGNED: "Management.Brands.LOCATION_ASSIGNED" /* LOCATION_ASSIGNED */,
      BILLING: "Management.Brands.BILLING" /* BILLING */
    },
    Cohorts: {
      MANAGE: "Management.Cohorts.MANAGE" /* MANAGE */
    },
    Groups: {
      VIEW: "Management.Groups.VIEW" /* VIEW */,
      CREATE: "Management.Groups.CREATE" /* CREATE */,
      DELETE: "Management.Groups.DELETE" /* DELETE */,
      UPDATE: "Management.Groups.UPDATE" /* UPDATE */,
      ALL: "Management.Groups.ALL" /* ALL */,
      AVAILABLE: "Management.Groups.AVAILABLE" /* AVAILABLE */,
      IN_BRAND: "Management.Groups.IN_BRAND" /* IN_BRAND */,
      ASSIGN_LOCATION: "Management.Groups.ASSIGN_LOCATION" /* ASSIGN_LOCATION */,
      UNASSIGN_LOCATION: "Management.Groups.UNASSIGN_LOCATION" /* UNASSIGN_LOCATION */,
      LOCATION_ASSIGNED: "Management.Groups.LOCATION_ASSIGNED" /* LOCATION_ASSIGNED */,
      SEND_TEST_LEAD: "Management.Groups.SEND_TEST_LEAD" /* SEND_TEST_LEAD */,
      PING_STATS: "Management.Groups.PING_STATS" /* PING_STATS */,
      DELETE_PING_ZIP: "Management.Groups.DELETE_PING_ZIP" /* DELETE_PING_ZIP */,
      RESET_PING_ZIP: "Management.Groups.RESET_PING_ZIP" /* RESET_PING_ZIP */,
      MANAGE_PING_POST: "Management.Groups.MANAGE_PING_POST" /* MANAGE_PING_POST */,
      ROUTING: "Managment.Groups.ROUTING" /* ROUTING */,
      ADD_UPDATE_TRACKDRIVE: "Management.Groups.ADD_UPDATE_TRACKDRIVE" /* ADD_UPDATE_TRACKDRIVE */,
      BRAND: "Management.Groups.BRAND" /* BRAND */,
      SUPER: "Management.Groups.SUPER" /* SUPER */,
      LEAD: "Management.Groups.LEAD" /* LEAD */,
      LEAD_STATS: "Management.Groups.LEAD_STATS" /* LEAD_STATS */,
      LOCATION: "Management.Groups.LOCATION" /* LOCATION */,
      MARKETING: "Management.Groups.MARKETING" /* MARKETING */,
      MEMBER: "Management.Groups.MEMBER" /* MEMBER */,
      SETTINGS: "Management.Groups.SETTINGS" /* SETTINGS */,
      INTEGRATION: "Management.Groups.INTEGRATION" /* INTEGRATION */,
      TRACK_DRIVE: "Management.Groups.TRACK_DRIVE" /* TRACK_DRIVE */,
      PING_LOGS: "Management.Groups.PING_LOGS" /* PING_LOGS */,
      TASK: "Management.Groups.TASK" /* TASK */,
      GLOBAL_TRACKDRIVE: "Management.Groups.GLOBAL_TRACKDRIVE" /* GLOBAL_TRACKDRIVE */,
      VIEW_TRANSFERS_OVERVIEW: "Management.Groups.VIEW_TRANSFERS_OVERVIEW" /* VIEW_TRANSFERS_OVERVIEW */
    },
    Members: {
      CREATE: "Management.Members.CREATE" /* CREATE */,
      VIEW: "Management.Members.VIEW" /* VIEW */,
      DELETE: "Management.Members.DELETE" /* DELETE */,
      UPDATE: "Management.Members.UPDATE" /* UPDATE */,
      ALL: "Management.Members.ALL" /* ALL */,
      GROUPS: "Management.Members.GROUPS" /* GROUPS */,
      ASSIGN_TO_GROUP: "Management.Members.ASSIGN_GROUP" /* ASSIGN_TO_GROUP */,
      UNASSIGN_FROM_GROUP: "Management.Members.UNASSIGN_FROM_GROUP" /* UNASSIGN_FROM_GROUP */,
      SITES: "Management.Members.SITES" /* SITES */,
      ACCOUNT_MANAGE: "Management.Members.ACCOUNT_MANAGE" /* ACCOUNT_MANAGE */,
      BRAND: "Management.Members.BRAND" /* BRAND */,
      GROUP: "Management.Members.GROUP" /* GROUP */,
      LEAD: "Management.Members.LEAD" /* LEAD */,
      LEAD_STATS: "Management.Members.LEAD_STATS" /* LEAD_STATS */,
      SUPER: "Management.Members.SUPER" /* SUPER */,
      USAGE_STATUS: "Management.Members.USAGE_STATUS" /* USAGE_STATUS */,
      INTEGRATION: "Management.Members.INTEGRATION" /* INTEGRATION */,
      NOTIFICATION: "Management.Members.NOTIFICATION" /* NOTIFICATION */,
      TASK: "Management.Members.TASK" /* TASK */,
      VIEW_MODIFY_UNCLAIMED_AGENT: "Management.Members.VIEW_MODIFY_UNCLAIMED_AGENT" /* VIEW_MODIFY_UNCLAIMED_AGENT */,
      VIEW_MODIFY_CLAIMED_AGENT: "Management.Members.VIEW_MODIFY_CLAIMED_AGENT" /* VIEW_MODIFY_CLAIMED_AGENT */
    },
    Tenants: {
      VIEW: "Management.Tenants.VIEW" /* VIEW */,
      UPDATE: "Management.Tenants.UPDATE" /* UPDATE */
    },
    Onboard: {
      CREATE_NEW_BRAND: "Management.Onboard.CREATE_NEW_BRAND" /* CREATE_NEW_BRAND */,
      CREATE_WIZARD: "Management.Onboard.CREATE_WIZARD" /* CREATE_WIZARD */,
      BRAND: "Management.Onboard.BRAND" /* BRAND */,
      TENANT: "Management.Onboard.TENANT" /* TENANT */,
      CONE_ZONE: "Management.Onboard.CONE_ZONE" /* CONE_ZONE */,
      CONE_ZONE_SUPER: "Management.Onboard.CONE_ZONE_SUPER" /* CONE_ZONE_SUPER */
    },
    Profile: {
      VIEW_MODIFY: "Management.Profile.VIEW_MODIFY" /* VIEW_MODIFY */,
      INTEGRATION: "Management.Profile.INTEGRATION" /* INTEGRATION */,
      BLOG: "Management.Profile.BLOG" /* BLOG */,
      REVIEWS: "Management.Profile.REVIEWS" /* REVIEWS */
    }
  }
};

// src/scopes/scope-info.ts
var scopeInfo = {
  General: {
    Leads: [
      {
        scope: "General.Leads.SUPER" /* SUPER */,
        description: "Allow role to have tenant level access to leads"
      },
      {
        scope: "General.Leads.BRAND" /* BRAND */,
        description: "Allow role to have brand level access to leads"
      },
      {
        scope: "General.Leads.BRAND_OWNERSHIP" /* BRAND_OWNERSHIP */,
        description: "Allow role to view all leads under child brandings of their brand ownership"
      },
      {
        scope: "General.Leads.VIEW" /* VIEW */,
        description: "Allow role to view leads (Navbar)"
      },
      {
        scope: "General.Leads.VIEW_HIDDEN" /* VIEW_HIDDEN */,
        description: "Allow role to view hidden leads"
      },
      {
        scope: "General.Leads.REASSIGN" /* REASSIGN */,
        description: "Allow role to reassign a lead"
      },
      {
        scope: "General.Leads.CREATE" /* CREATE */,
        description: "Allow role to create leads"
      },
      {
        scope: "General.Leads.DELETE" /* DELETE */,
        description: "Allow role to delete leads"
      },
      {
        scope: "General.Leads.UPDATE" /* UPDATE */,
        description: "Allow role to update leads"
      },
      {
        scope: "General.Leads.WARM_TRANSFER" /* WARM_TRANSFER */,
        description: "Allow role to warm transfer"
      },
      {
        scope: "General.Leads.LEAD_SOURCE_FILTER" /* LEAD_SOURCE_FILTER */,
        description: "Allow role to filter by lead sources"
      },
      {
        scope: "General.Leads.NOTES" /* NOTES */,
        description: "Allow role to interact using notes"
      },
      {
        scope: "General.Leads.STAGE_CHANGE" /* STAGE_CHANGE */,
        description: "Allow role to view stage changes"
      },
      {
        scope: "General.Leads.LEAD_ASSIST" /* LEAD_ASSIST */,
        description: "Allow role to use lead assist"
      },
      {
        scope: "General.Leads.ONLY_PRIMARY_GROUP" /* ONLY_PRIMARY_GROUP */,
        description: "Allow role to see only primary group leads"
      },
      {
        scope: "General.Leads.RESTRICTED_LEAD_SOURCE_ACCESS" /* RESTRICTED_LEAD_SOURCE_ACCESS */,
        description: "Restrict role to access leads based on restricted lead source"
      },
      {
        scope: "General.Leads.HIDE_OWNER_INFO" /* HIDE_OWNER_INFO */,
        description: "Hide owner info from dashboard/leads table/lead detail"
      }
    ],
    Scorecard: [
      {
        scope: "General.Scorecard.ACCESS" /* ACCESS */,
        description: "Allow role to see and log the agent scorecard rings on lead detail (rollout gate, fail-closed)"
      },
      {
        scope: "General.Scorecard.VIEW_TEAM" /* VIEW_TEAM */,
        description: "Allow role to view team scorecards (coach/leadership rollups \u2014 reserved, unused in v1)"
      },
      {
        scope: "General.Scorecard.LEADERBOARD" /* LEADERBOARD */,
        description: "Allow role to see their own standing on their brand leaderboard (agent-facing)"
      },
      {
        scope: "General.Scorecard.VIEW_ALL" /* VIEW_ALL */,
        description: "Allow role to view all brands' scorecards & leaderboards (cross-brand \u2014 no super_admin required)"
      }
    ],
    Settings: [
      {
        scope: "General.Settings.ACCESS",
        description: "Allow role to access tra panel"
      }
    ]
  },
  Management: {
    Account: [
      {
        scope: "Management.Members.ACCOUNT_MANAGE" /* ACCOUNT_MANAGE */,
        description: "Allow role to manage their account"
      }
    ],
    Roles: [
      {
        scope: "Management.Roles.CREATE",
        description: "Allow role to create role"
      },
      {
        scope: "Management.Roles.DELETE",
        description: "Allow role to delete role"
      },
      {
        scope: "Management.Roles.UPDATE",
        description: "Allow role to update role"
      },
      {
        scope: "Management.Roles.LIST",
        description: "Allow role to list role"
      },
      {
        scope: "Management.Roles.IS_SUPER_ADMIN",
        description: "Allow role to have super admin access"
      },
      {
        scope: "Management.Roles.IS_BRAND_ADMIN",
        description: "Allow role to have brand admin access"
      }
    ],
    Campaigns: [
      {
        scope: "Management.Campaigns.SUPER" /* SUPER */,
        description: "Allow role to have tenant level access to campaigns"
      },
      {
        scope: "Management.Campaigns.BRAND" /* BRAND */,
        description: "Allow role to have brand level access to campaigns"
      },
      {
        scope: "Management.Campaigns.VIEW" /* VIEW */,
        description: "Allow role to view campaign (Navbar)"
      },
      {
        scope: "Management.Campaigns.CREATE_ASSIGNMENT",
        description: "Allow role to create campaign assignments"
      },
      {
        scope: "Management.Campaigns.UPDATE_ASSIGNMENT",
        description: "Allow role to update campaign assignments"
      },
      {
        scope: "Management.Campaigns.ASSIGNED",
        description: "Allow role to access campaign assigned table"
      },
      {
        scope: "Management.Campaigns.DELETE_ASSIGNED",
        description: "Allow role to delete assigned campaign"
      },
      {
        scope: "Management.Campaigns.ALL",
        description: "Allow role to access campaign table"
      },
      {
        scope: "Management.Campaigns.CREATE",
        description: "Allow role to create campaign"
      },
      {
        scope: "Management.Campaigns.UPDATE",
        description: "Allow role to update campaign"
      }
    ],
    Brands: [
      {
        scope: "Management.Brands.CREATE",
        description: "Allow role to create brands"
      },
      {
        scope: "Management.Brands.DELETE",
        description: "Allow role to delete brands"
      },
      {
        scope: "Management.Brands.UPDATE",
        description: "Allow role to update brands"
      },
      {
        scope: "Management.Brands.VIEW",
        description: "Allow role to view brands"
      },
      {
        scope: "Management.Brands.ZOHO_SYNC",
        description: "Allow role to perform Zoho Sync"
      },
      {
        scope: "Management.Brands.ALL",
        description: "Allow role to access brands table"
      },
      {
        scope: "Management.Brands.LOCATION_ADD",
        description: "Allow role to add location on brands"
      },
      {
        scope: "Management.Brands.LOCATION_REMOVE",
        description: "Allow role to remove location on brands"
      },
      {
        scope: "Management.Brands.LOCATION_ASSIGNED",
        description: "Allow role to access assigned locations on brands"
      },
      {
        scope: "Management.Brands.BILLING" /* BILLING */,
        description: "Allow role to access billing table and dashboard"
      }
    ],
    Cohorts: [
      {
        scope: "Management.Cohorts.MANAGE" /* MANAGE */,
        description: "Allow role to create, rename and delete cohorts and assign agents to them, for its own brand tree; with Management.Brands.VIEW (or super_admin / Scorecard.VIEW_ALL), for any brand. The brand-page Cohorts tab also requires Management.Brands.VIEW"
      }
    ],
    Groups: [
      {
        scope: "Management.Groups.VIEW",
        description: "Allow role to view groups"
      },
      {
        scope: "Management.Groups.CREATE",
        description: "Allow role to create groups"
      },
      {
        scope: "Management.Groups.DELETE",
        description: "Allow role to delete groups"
      },
      {
        scope: "Management.Groups.UPDATE",
        description: "Allow role to update groups"
      },
      {
        scope: "Management.Groups.ALL",
        description: "Allow role to access groups table"
      },
      {
        scope: "Management.Groups.AVAILABLE",
        description: "Allow role to access available groups"
      },
      {
        scope: "Management.Groups.IN_BRAND",
        description: "Allow role to access in-brand section"
      },
      {
        scope: "Management.Groups.ASSIGN_LOCATION",
        description: "Allow role to assign location to groups"
      },
      {
        scope: "Management.Groups.UNASSIGN_LOCATION",
        description: "Allow role to unassign location to groups"
      },
      {
        scope: "Management.Groups.LOCATION_ASSIGNED",
        description: "Allow role to access assigned location to groups"
      },
      {
        scope: "Management.Groups.SEND_TEST_LEAD",
        description: "Allow role to send test lead to groups"
      },
      {
        scope: "Management.Groups.MANAGE_PING_POST",
        description: "Allow role to manage ping/post filter sets, Boberdoo sync, and ping-post configuration"
      },
      {
        scope: "Management.Groups.PING_STATS",
        description: "Allow role to ping stats"
      },
      {
        scope: "Management.Groups.DELETE_PING_ZIP",
        description: "Allow role to delete ping zip"
      },
      {
        scope: "Management.Groups.RESET_PING_ZIP",
        description: "Allow role to reset ping zip"
      },
      {
        scope: "Management.Groups.SUPER" /* SUPER */,
        description: "Allow role to see all tenant groups"
      },
      {
        scope: "Management.Groups.BRAND" /* BRAND */,
        description: "Allow role to see all brand groups in brand"
      },
      {
        scope: "Management.Groups.MEMBER" /* MEMBER */,
        description: "Allow role to see group members (tab)"
      },
      {
        scope: "Management.Groups.LEAD" /* LEAD */,
        description: "Allow role to see group leads (tab)"
      },
      {
        scope: "Management.Groups.LEAD_STATS" /* LEAD_STATS */,
        description: "Allow role to see lead stats (tab)"
      },
      {
        scope: "Management.Groups.MARKETING" /* MARKETING */,
        description: "Allow role to see group marketing (tab)"
      },
      {
        scope: "Management.Groups.LOCATION" /* LOCATION */,
        description: "Allow role to see assigned location (tab)"
      },
      {
        scope: "Management.Groups.SETTINGS" /* SETTINGS */,
        description: "Allow role to see group settings (tab)"
      },
      {
        scope: "Management.Groups.INTEGRATION" /* INTEGRATION */,
        description: "Allow role to see group integrations (tab)"
      },
      {
        scope: "Management.Groups.TRACK_DRIVE" /* TRACK_DRIVE */,
        description: "Allow role to see group trackdrive (tab)"
      },
      {
        scope: "Management.Groups.ADD_UPDATE_TRACKDRIVE" /* ADD_UPDATE_TRACKDRIVE */,
        description: "Allow role to see add/update/delete trackdrive"
      },
      {
        scope: "Management.Groups.PING_LOGS" /* PING_LOGS */,
        description: "Allow role to Access Ping LOGS"
      },
      {
        scope: "Management.Groups.GLOBAL_TRACKDRIVE" /* GLOBAL_TRACKDRIVE */,
        description: "Allow role to see global trackdrive table"
      },
      {
        scope: "Management.Groups.VIEW_TRANSFERS_OVERVIEW" /* VIEW_TRANSFERS_OVERVIEW */,
        description: "Allow role to see transfers overview table"
      },
      {
        scope: "Managment.Groups.ROUTING" /* ROUTING */,
        description: "Allow role to manage group routing and round-robin configuration"
      }
    ],
    Members: [
      {
        scope: "Management.Members.VIEW" /* VIEW */,
        description: "Allow role to view members (Navbar)"
      },
      {
        scope: "Management.Members.BRAND" /* BRAND */,
        description: "Allow role to access members of a brand"
      },
      {
        scope: "Management.Members.SUPER" /* SUPER */,
        description: "Allow role to access members of a Tenant. Either select brand or super"
      },
      {
        scope: "Management.Members.GROUP" /* GROUP */,
        description: "Allow role to access members group"
      },
      {
        scope: "Management.Members.CREATE" /* CREATE */,
        description: "Allow role to create new members"
      },
      {
        scope: "Management.Members.DELETE" /* DELETE */,
        description: "Allow role to delete members"
      },
      {
        scope: "Management.Members.UPDATE" /* UPDATE */,
        description: "Allow role to update members"
      },
      {
        scope: "Management.Members.ASSIGN_GROUP" /* ASSIGN_TO_GROUP */,
        description: "Allow role to assign members to groups"
      },
      {
        scope: "Management.Members.UNASSIGN_FROM_GROUP" /* UNASSIGN_FROM_GROUP */,
        description: "Allow role to unassign member from groups"
      },
      {
        scope: "Management.Members.SITES" /* SITES */,
        description: "Allow role to access sites of members"
      },
      {
        scope: "Management.Members.LEAD" /* LEAD */,
        description: "Allow role to access member leads (tab)"
      },
      {
        scope: "Management.Members.LEAD_STATS" /* LEAD_STATS */,
        description: "Allow role to access member leads stats (tab)"
      },
      {
        scope: "Management.Members.INTEGRATION" /* INTEGRATION */,
        description: "Allow role to access member integration (tab)"
      },
      {
        scope: "Management.Members.NOTIFICATION" /* NOTIFICATION */,
        description: "Allow role to access member notification (tab)"
      },
      {
        scope: "Management.Members.USAGE_STATUS" /* USAGE_STATUS */,
        description: "Allow role to export member usage status"
      },
      {
        scope: "Management.Members.VIEW_MODIFY_UNCLAIMED_AGENT" /* VIEW_MODIFY_UNCLAIMED_AGENT */,
        description: "Allow role to view and modify unclaimed agent"
      },
      {
        scope: "Management.Members.VIEW_MODIFY_CLAIMED_AGENT" /* VIEW_MODIFY_CLAIMED_AGENT */,
        description: "Allow role to view and modify a claimed agent"
      }
    ],
    Tenants: [
      {
        scope: "Management.Tenants.VIEW",
        description: "Allow role to view tenants"
      },
      {
        scope: "Management.Tenants.UPDATE",
        description: "Allow role to update tenants"
      }
    ],
    Onboard: [
      {
        scope: "Management.Onboard.TENANT" /* TENANT */,
        description: "Allow role to onboard a member for tenant"
      },
      {
        scope: "Management.Onboard.BRAND" /* BRAND */,
        description: "Allow role to onboard a member for a brand"
      },
      {
        scope: "Management.Onboard.CONE_ZONE" /* CONE_ZONE */,
        description: "Allow role to use cone zone"
      },
      {
        scope: "Management.Onboard.CONE_ZONE_SUPER" /* CONE_ZONE_SUPER */,
        description: "Allow role to use cone zone super"
      }
    ],
    Tasks: [
      {
        scope: "Management.Tasks.VIEW" /* VIEW */,
        description: "Allow Role to acces task management side nav"
      },
      {
        scope: "Management.Tasks.SUPER" /* SUPER */,
        description: "Allow role have super level control over task management"
      },
      {
        scope: "Management.Tasks.BRAND" /* BRAND */,
        description: "Allow role to have brand level control over task management"
      },
      {
        scope: "Management.Groups.TASK" /* TASK */,
        description: "Allow role to see group tasks (tab)"
      },
      {
        scope: "Management.Members.TASK" /* TASK */,
        description: "Allow role to access member tasks (tab)"
      }
    ],
    Profile: [
      {
        scope: "Management.Profile.VIEW_MODIFY" /* VIEW_MODIFY */,
        description: "Allow role to view and modify profile"
      },
      {
        scope: "Management.Profile.INTEGRATION" /* INTEGRATION */,
        description: "Allow role to access profile integrations"
      },
      {
        scope: "Management.Profile.BLOG" /* BLOG */,
        description: "Allow role to access profile blog"
      },
      {
        scope: "Management.Profile.REVIEWS" /* REVIEWS */,
        description: "Allow role to access profile reviews"
      }
    ]
  }
};

// src/scopes/catalog.ts
var SCOPE_CATALOG = [
  // General.Account
  "General.Account.CAN_DELETE_OWN_ACCOUNT",
  "General.Account.MANAGE",
  "General.Account.VIEW_LOGIN_HISTORY",
  // General.Dashboard
  "General.Dashboard.ALL",
  "General.Dashboard.BRAND",
  "General.Dashboard.PERSONAL",
  "General.Dashboard.VIEW",
  // General.Inquiry
  "General.Inquiry.ALL",
  "General.Inquiry.LEAD",
  // General.Leads
  "General.Leads.ALL",
  "General.Leads.BRAND",
  "General.Leads.BRAND_OWNERSHIP",
  "General.Leads.CREATE",
  "General.Leads.DELETE",
  "General.Leads.FILTER_BY_BRANDS",
  "General.Leads.FILTER_BY_BRAND_GROUPS",
  "General.Leads.FILTER_BY_LEAD_SOURCES",
  "General.Leads.HIDE_OWNER_INFO",
  "General.Leads.LEAD_ASSIST",
  "General.Leads.LEAD_SOURCE_FILTER",
  "General.Leads.NOTES",
  "General.Leads.OMNISEARCH",
  "General.Leads.ONLY_PRIMARY_GROUP",
  "General.Leads.PERSONAL",
  "General.Leads.REASSIGN",
  "General.Leads.RESTRICTED_LEAD_SOURCE_ACCESS",
  "General.Leads.STAGE_CHANGE",
  "General.Leads.SUPER",
  "General.Leads.UPDATE",
  "General.Leads.VIEW",
  "General.Leads.VIEW_HIDDEN",
  "General.Leads.VIEW_INQUIRIES",
  "General.Leads.VIEW_PROPERTIES",
  "General.Leads.VIEW_REQUESTS",
  "General.Leads.VIEW_SEARCHES",
  "General.Leads.WARM_TRANSFER",
  // General.Notes
  "General.Notes.COMMENT",
  "General.Notes.COMMENT_DELETE",
  "General.Notes.CREATE",
  "General.Notes.DELETE",
  // General.Property
  "General.Property.ALL",
  "General.Property.LEAD",
  // General.SavedSearch
  "General.SavedSearch.ALL",
  "General.SavedSearch.LEAD",
  // General.Scorecard
  "General.Scorecard.ACCESS",
  "General.Scorecard.LEADERBOARD",
  "General.Scorecard.VIEW_ALL",
  "General.Scorecard.VIEW_TEAM",
  // General.Settings
  "General.Settings.ACCESS",
  // General.ShowingRequest
  "General.ShowingRequest.ALL",
  "General.ShowingRequest.LEAD",
  // Management.Brands
  "Management.Brands.ALL",
  "Management.Brands.BILLING",
  "Management.Brands.CREATE",
  "Management.Brands.DELETE",
  "Management.Brands.LOCATION_ADD",
  "Management.Brands.LOCATION_ASSIGNED",
  "Management.Brands.LOCATION_REMOVE",
  "Management.Brands.UPDATE",
  "Management.Brands.VIEW",
  "Management.Brands.ZOHO_SYNC",
  // Management.Campaigns
  "Management.Campaigns.ALL",
  "Management.Campaigns.ASSIGNED",
  "Management.Campaigns.BRAND",
  "Management.Campaigns.CREATE",
  "Management.Campaigns.CREATE_ASSIGNMENT",
  "Management.Campaigns.DELETE_ASSIGNED",
  "Management.Campaigns.SUPER",
  "Management.Campaigns.UPDATE",
  "Management.Campaigns.UPDATE_ASSIGNMENT",
  "Management.Campaigns.VIEW",
  // Management.Cohorts
  "Management.Cohorts.MANAGE",
  // Management.Groups
  "Management.Groups.ADD_UPDATE_TRACKDRIVE",
  "Management.Groups.ALL",
  "Management.Groups.ASSIGN_LOCATION",
  "Management.Groups.AVAILABLE",
  "Management.Groups.BRAND",
  "Management.Groups.CREATE",
  "Management.Groups.DELETE",
  "Management.Groups.DELETE_PING_ZIP",
  "Management.Groups.GLOBAL_TRACKDRIVE",
  "Management.Groups.INTEGRATION",
  "Management.Groups.IN_BRAND",
  "Management.Groups.LEAD",
  "Management.Groups.LEAD_STATS",
  "Management.Groups.LOCATION",
  "Management.Groups.LOCATION_ASSIGNED",
  "Management.Groups.MANAGE_PING_POST",
  "Management.Groups.MARKETING",
  "Management.Groups.MEMBER",
  "Management.Groups.PING_LOGS",
  "Management.Groups.PING_STATS",
  "Management.Groups.PING_ZIPS",
  "Management.Groups.RESET_PING_ZIP",
  "Management.Groups.SEND_TEST_LEAD",
  "Management.Groups.SETTINGS",
  "Management.Groups.SUPER",
  "Management.Groups.TASK",
  "Management.Groups.TRACK_DRIVE",
  "Management.Groups.UNASSIGN_LOCATION",
  "Management.Groups.UPDATE",
  "Management.Groups.VIEW",
  "Management.Groups.VIEW_TRANSFERS_OVERVIEW",
  // Management.Members
  "Management.Members.ACCOUNT_MANAGE",
  "Management.Members.ALL",
  "Management.Members.ASSIGN_GROUP",
  "Management.Members.BRAND",
  "Management.Members.CREATE",
  "Management.Members.DELETE",
  "Management.Members.GROUP",
  "Management.Members.GROUPS",
  "Management.Members.INTEGRATION",
  "Management.Members.LEAD",
  "Management.Members.LEAD_STATS",
  "Management.Members.MANAGE_TRANSFER_AGENTS",
  "Management.Members.NOTIFICATION",
  "Management.Members.SITES",
  "Management.Members.SUPER",
  "Management.Members.TASK",
  "Management.Members.UNASSIGN_FROM_GROUP",
  "Management.Members.UPDATE",
  "Management.Members.USAGE_STATUS",
  "Management.Members.VIEW",
  "Management.Members.VIEW_MODIFY_CLAIMED_AGENT",
  "Management.Members.VIEW_MODIFY_UNCLAIMED_AGENT",
  // Management.Onboard
  "Management.Onboard.BRAND",
  "Management.Onboard.CONE_ZONE",
  "Management.Onboard.CONE_ZONE_SUPER",
  "Management.Onboard.CREATE_NEW_BRAND",
  "Management.Onboard.CREATE_WIZARD",
  "Management.Onboard.TENANT",
  // Management.Profile
  "Management.Profile.BLOG",
  "Management.Profile.INTEGRATION",
  "Management.Profile.REVIEWS",
  "Management.Profile.VIEW",
  "Management.Profile.VIEW_MODIFY",
  // Management.Roles
  "Management.Roles.CREATE",
  "Management.Roles.DELETE",
  "Management.Roles.IS_BRAND_ADMIN",
  "Management.Roles.IS_SUPER_ADMIN",
  "Management.Roles.LIST",
  "Management.Roles.UPDATE",
  // Management.Tasks
  "Management.Tasks.BRAND",
  "Management.Tasks.SUPER",
  "Management.Tasks.VIEW",
  // Management.Tenants
  "Management.Tenants.UPDATE",
  "Management.Tenants.VIEW",
  // Management.Translation
  "Management.Translation.CREATE",
  "Management.Translation.LIST",
  "Management.Translation.UPDATE",
  // Managment.Groups
  "Managment.Groups.ROUTING"
];
var isKnownScope = (value) => SCOPE_CATALOG.includes(value);

// src/scopes/index.ts
var scope = {
  config,
  info: scopeInfo,
  /** Every scope a role may legitimately hold — see catalog.ts. */
  catalog: SCOPE_CATALOG
};

// src/utils/to-lat-lon.ts
function tile2long(x, z4) {
  return x / 2 ** z4 * 360 - 180;
}
function tile2lat(y, z4) {
  const n = Math.PI - 2 * Math.PI * y / 2 ** z4;
  return 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
}
var toLonLat = (x, y, z4) => [
  tile2long(x, z4),
  tile2lat(y, z4)
];

// src/utils/parse-message-for-mention.ts
var parseMessageForMention = (message) => {
  const regex = /@\[([^\]]+)\]\((\d+)\)/g;
  let match;
  let lastIndex = 0;
  const parts = [];
  while ((match = regex.exec(message)) !== null) {
    if (match.index > lastIndex) {
      parts.push(message.substring(lastIndex, match.index));
    }
    parts.push({ name: match[1], id: match[2] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < message.length) {
    parts.push(message.substring(lastIndex));
  }
  return parts;
};

// src/utils/get-price-on-population.ts
var populationPricingModel = [
  { from: 157e4, to: Infinity, price: 15e3 },
  { from: 375e3, to: 1569999, price: 7500 },
  { from: 175e3, to: 374999, price: 5e3 },
  { from: 1e5, to: 174999, price: 2500 },
  { from: 5e4, to: 99999, price: 1500 },
  { from: 4e4, to: 49999, price: 1e3 },
  { from: 5e3, to: 39999, price: 500 },
  { from: 0, to: 4999, price: 100 }
];
var getPriceBasedOnPopulation = (population) => {
  if (typeof population !== "number" || isNaN(population) || population < 0) {
    return 0;
  }
  const range = populationPricingModel.find(
    (r) => population >= r.from && population <= (r.to === Infinity ? population : r.to)
  );
  if (!range) {
    throw new Error("Population out of range: " + population);
  }
  return range.price;
};

// src/utils/social-links/types.ts
var TYPE_DESKTOP = 0;
var TYPE_MOBILE = 1;
var TYPE_DEFAULT = Infinity;

// src/utils/social-links/profiles/facebook.ts
var facebook = {
  name: "facebook",
  matches: [
    {
      match: "(https?://)?(www.)?facebook.com/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://facebook.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?m.facebook.com/({PROFILE_ID})/?",
      group: 2,
      type: TYPE_MOBILE,
      pattern: "https://m.facebook.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?(www.)?facebook.com/people/([^/]+)/([^/?]+)/?",
      group: 4,
      type: TYPE_DESKTOP,
      pattern: "https://www.facebook.com/people/{NAME}/{PROFILE_ID}"
    },
    {
      match: "(https?://)?(www.)?facebook.com/profile.php\\?id=({PROFILE_ID})",
      // New match for profile.php URLs
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://www.facebook.com/profile.php?id={PROFILE_ID}"
      // Pattern for this match
    },
    {
      match: "({PROFILE_ID})",
      group: 1
    }
  ]
};

// src/utils/social-links/profiles/github.ts
var github = {
  name: "github",
  matches: [
    {
      match: "(https?://)?(www.)?github.com/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://github.com/{PROFILE_ID}"
    },
    { match: "({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/instagram.ts
var instagram = {
  name: "instagram",
  matches: [
    {
      match: "(https?://)?(www.)?instagram.com/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://instagram.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?m.instagram.com/({PROFILE_ID})/?",
      group: 2,
      type: TYPE_MOBILE,
      pattern: "https://m.instagram.com/{PROFILE_ID}"
    },
    { match: "@?({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/linkedin.ts
var linkedin = {
  name: "linkedin",
  matches: [
    {
      match: "(https?://)?([a-z]{2,3}.)?linkedin.com/in/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://linkedin.com/in/{PROFILE_ID}"
    },
    {
      match: "(https?://)?([a-z]{2,3}.)?linkedin.com/mwlite/in/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_MOBILE,
      pattern: "https://linkedin.com/mwlite/in/{PROFILE_ID}"
    },
    {
      match: "(https?://)?([a-z]{2,3}.)?linkedin.com/pub/([a-z]+)-([a-z]+)/(\\d+)/(\\d+)/(\\d+)/?",
      group: 0,
      type: TYPE_DESKTOP,
      pattern: "https://linkedin.com/in/{FIRST_NAME}-{LAST_NAME}-{PART3}{PART2}{PART1}"
    },
    {
      match: "({PROFILE_ID})",
      group: 1
    }
  ]
};

// src/utils/social-links/profiles/pinterest.ts
var pinterest = {
  name: "pinterest",
  matches: [
    {
      match: "(https?://)?([a-z]{1,3}.)?pinterest.com/({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://pinterest.com/{PROFILE_ID}"
    },
    { match: "@?({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/tiktok.ts
var tiktok = {
  name: "tiktok",
  matches: [
    {
      match: "(https?://)?(www.)?tiktok.com/@({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://tiktok.com/@{PROFILE_ID}"
    },
    { match: "@?({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/twitter.ts
var twitter = {
  name: "twitter",
  matches: [
    {
      match: "(https?://)?(www.)?twitter.com/@?({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://twitter.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?mobile.twitter.com/@?({PROFILE_ID})/?",
      group: 2,
      type: TYPE_MOBILE,
      pattern: "https://mobile.twitter.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?(www.)?x.com/@?({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://x.com/{PROFILE_ID}"
    },
    {
      match: "(https?://)?mobile.x.com/@?({PROFILE_ID})/?",
      group: 2,
      type: TYPE_MOBILE,
      pattern: "https://mobile.x.com/{PROFILE_ID}"
    },
    { match: "@?({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/youtube.ts
var youtube = {
  name: "youtube",
  matches: [
    {
      match: "(https?://)?(www.)?youtube.com/@?({PROFILE_ID})/?",
      group: 3,
      type: TYPE_DESKTOP,
      pattern: "https://youtube.com/@{PROFILE_ID}"
    },
    {
      match: "(https?://)?(www.)?youtube.com/channel/({PROFILE_ID})/?",
      group: 3
    },
    {
      match: "(https?://)?(www.)?youtube.com/user/({PROFILE_ID})/?",
      group: 3
    },
    {
      match: "(https?://)?m.youtube.com/c/({PROFILE_ID})/?",
      group: 2
    },
    { match: "({PROFILE_ID})", group: 1 }
  ]
};

// src/utils/social-links/profiles/index.ts
var PREDEFINED_PROFILES = [
  facebook,
  github,
  instagram,
  linkedin,
  pinterest,
  tiktok,
  twitter,
  youtube
];

// src/utils/social-links/main.ts
var PROFILE_ID = "[A-Za-z0-9_\\-\\.]+";
var QUERY_PARAM = "(\\?.*)?";
var createRegexp = (profileMatch, config2) => {
  const str = profileMatch.match.replace("{PROFILE_ID}", `${PROFILE_ID}`);
  const isTyped = typeof profileMatch.type !== "undefined";
  const regexp = new RegExp(
    [
      "^",
      str,
      ...config2.allowQueryParams && isTyped ? [QUERY_PARAM] : [],
      "$"
    ].join("")
  );
  return regexp;
};
var findIndex = (matches, link, config2) => {
  return (matches != null ? matches : []).findIndex(
    (match) => createRegexp(match, config2).test(link)
  );
};
var DEFAULT_CONFIG = {
  usePredefinedProfiles: true,
  trimInput: true,
  allowQueryParams: false
};
var SocialLinks = class {
  constructor(config2 = DEFAULT_CONFIG) {
    if (typeof config2 === "boolean") {
      config2 = { usePredefinedProfiles: config2 };
    }
    this.config = __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config2);
    this.profiles = /* @__PURE__ */ new Map();
    if (this.config.usePredefinedProfiles) {
      PREDEFINED_PROFILES.map(
        ({ name, matches }) => this.addProfile(name, matches)
      );
    }
  }
  trim(input) {
    return this.config.trimInput ? input.trim() : input;
  }
  addProfile(profileName, profileMatches) {
    if (this.hasProfile(profileName))
      return false;
    this.profiles.set(profileName, profileMatches);
    return true;
  }
  cleanProfiles() {
    this.profiles.clear();
  }
  isValid(profileName, link) {
    if (!this.hasProfile(profileName))
      return false;
    const matches = this.profiles.get(profileName);
    return findIndex(matches, this.trim(link), this.config) !== -1;
  }
  getProfileId(profileName, link) {
    var _a2, _b;
    if (!this.hasProfile(profileName))
      throw new Error(`There is no profile ${profileName} defined`);
    const matches = (_a2 = this.profiles.get(profileName)) != null ? _a2 : [];
    const trimmed = this.trim(link);
    const idx = findIndex(matches, trimmed, this.config);
    if (idx === -1)
      throw new Error(`Link has not matched with profile ${profileName}`);
    return ((_b = trimmed.match(createRegexp(matches[idx], this.config))) != null ? _b : [])[matches[idx].group];
  }
  getLink(profileName, id, type = TYPE_DEFAULT) {
    var _a2, _b;
    if (!this.hasProfile(profileName))
      throw new Error(`There is no profile ${profileName} defined`);
    const matches = (_a2 = this.profiles.get(profileName)) != null ? _a2 : [];
    const weakType = type === TYPE_DEFAULT ? TYPE_DESKTOP : type;
    const idx = matches.findIndex((match) => {
      if (type === TYPE_DEFAULT)
        return true;
      return match.type === weakType;
    });
    if (idx === -1)
      throw new Error(`There is no pattern for profile ${profileName}`);
    return ((_b = matches[idx].pattern) != null ? _b : "").replace(
      "{PROFILE_ID}",
      `${this.trim(id)}`
    );
  }
  sanitize(profileName, link, type = TYPE_DEFAULT) {
    var _a2, _b;
    const trimmed = this.trim(link);
    const profileId = this.getProfileId(profileName, trimmed);
    const matches = (_a2 = this.profiles.get(profileName)) != null ? _a2 : [];
    const idx = findIndex(matches, trimmed, this.config);
    const matchedType = type !== TYPE_DEFAULT ? type : (_b = matches[idx].type) != null ? _b : TYPE_DEFAULT;
    return this.getLink(profileName, profileId, matchedType);
  }
  hasProfile(profileName) {
    return this.profiles.has(profileName);
  }
  getProfileNames() {
    return [...this.profiles.keys()];
  }
  // list all matching profiles sorted by score
  scoreProfiles(link) {
    return this.getProfileNames().map((profileName) => {
      const matches = this.profiles.get(profileName);
      const score = (matches || []).reduce((sum, match) => {
        return sum + (createRegexp(match, this.config).test(link) ? 1 : 0);
      }, 0);
      return { profileName, score };
    }).filter((obj) => obj.score > 0).sort((a, b) => b.score - a.score);
  }
  // return first matching profile
  detectProfile(link) {
    const scores = this.scoreProfiles(link);
    if (scores.length === 0)
      return "";
    return scores[0].profileName;
  }
};

// src/utils/generate-value-url.ts
var formatAddressForUrl = (address) => {
  if (!address)
    return "";
  return address.replace(/,/g, "").replace(/ /g, "-").replace("#", "unit-").trim().toLowerCase();
};
var buildValueUrl = (formattedAddress, propertyId) => {
  if (!formattedAddress)
    return "";
  const suffix = propertyId ? `-${propertyId}` : "";
  return `/my-value/${formattedAddress}${suffix}`;
};
var generateValueUrl = (payload) => {
  if (payload.validatedAddress) {
    return generateValueUrlFromValidatedAddress(payload.validatedAddress);
  }
  if (payload.placekeyData) {
    return generateValueUrlFromPlacekeyData(payload);
  }
  return "";
};
var generateValueUrlFromPlacekeyData = (payload) => {
  var _a2;
  const externalIds = (_a2 = payload.placekeyData) == null ? void 0 : _a2.external_ids;
  if (!externalIds)
    return "";
  const propertyId = externalIds.public_record_id || (externalIds.cid ? `${externalIds.cid}c` : "");
  const formattedAddress = formatAddressForUrl(payload.formattedAddress);
  return buildValueUrl(formattedAddress, propertyId);
};
var generateValueUrlFromValidatedAddress = (validatedAddress) => {
  const property = validatedAddress == null ? void 0 : validatedAddress.Property;
  if (!property)
    return "";
  const propertyId = String(property.PropertyId || property.ExternalId || "");
  const formattedAddress = formatAddressForUrl(property.FullAddress);
  return buildValueUrl(formattedAddress, propertyId);
};

// src/lib/todos/schema.ts
var schema_exports = {};
__export(schema_exports, {
  assignMember: () => assignMember,
  createComment: () => createComment,
  createFullEpic: () => createFullEpic,
  createTodo: () => createTodo,
  createTodoEpic: () => createTodoEpic,
  createTodoEpicResponse: () => createTodoEpicResponse,
  createTodoList: () => createTodoList,
  createTodoResponse: () => createTodoResponse,
  deleteTodo: () => deleteTodo,
  entityTodosResponse: () => entityTodosResponse,
  epicParams: () => epicParams,
  getAssignedMemberById: () => getAssignedMemberById,
  getCommentById: () => getCommentById,
  getEntityTodoEpicById: () => getEntityTodoEpicById,
  getEntityTodoEpics: () => getEntityTodoEpics,
  getTodoById: () => getTodoById,
  getTodoListById: () => getTodoListById,
  taskTableQuery: () => taskTableQuery,
  taskTableQueryOpts: () => taskTableQueryOpts,
  todo: () => todo,
  todoItemParams: () => todoItemParams,
  toggle: () => toggle,
  updateTodo: () => updateTodo,
  updateTodoEpic: () => updateTodoEpic,
  updateTodoList: () => updateTodoList
});
import z2 from "zod";

// src/lib/base/schema.ts
import z from "zod";
var tablePagination = z.object({
  page: z.coerce.number().min(0),
  limit: z.coerce.number().max(100)
});
var tableQuery = z.object({
  searchText: z.string().optional(),
  pagination: tablePagination
});
var tableData = z.object({
  currentPage: z.number(),
  limit: z.number(),
  totalItems: z.number()
});
var tableFilterExpression = z.object({
  operator: z.union([
    z.literal("contains"),
    z.literal("startsWith"),
    z.literal("endsWith"),
    z.literal("=")
  ])
});

// src/lib/todos/schema.ts
var base = z2.object({
  entityId: z2.number(),
  title: z2.string().min(3).max(255),
  description: z2.string().min(10).max(3e3),
  priority: z2.union([z2.literal("high"), z2.literal("medium"), z2.literal("low")]),
  deadlineAt: z2.date().optional().nullable(),
  completedAt: z2.date().optional().nullable()
});
var entityType = z2.union([
  z2.literal("cone_zone"),
  z2.literal("member"),
  z2.literal("brand_group"),
  z2.literal("customer"),
  z2.literal("brand")
]);
var memberSchema = z2.object({
  id: z2.number(),
  firstName: z2.string(),
  email: z2.string(),
  lastName: z2.string()
});
var todo = base.merge(
  z2.object({
    id: z2.number(),
    type: entityType,
    createdAt: z2.date().optional(),
    updatedAt: z2.date().optional(),
    createdById: z2.number().optional().nullable(),
    archivedAt: z2.date().optional().nullable(),
    completedById: z2.number().optional().nullable(),
    createdBy: memberSchema.optional().nullable(),
    completedBy: memberSchema.optional().nullable()
  })
);
var entityTodosResponse = todo.array();
var createTodo = z2.object({
  title: z2.string().min(1).max(255),
  description: z2.string().max(3e3).default(""),
  todoListId: z2.number()
});
var ent = z2.object({
  type: entityType,
  entityId: z2.coerce.number()
});
var todoItemParams = z2.object({
  epicId: z2.coerce.number(),
  listId: z2.coerce.number()
}).merge(ent);
var createTodoResponse = z2.object({
  id: z2.number(),
  createdAt: z2.string(),
  updatedAt: z2.string()
});
var updateTodo = z2.object({
  id: z2.number()
}).merge(createTodo.partial());
var deleteTodo = base.merge(
  z2.object({
    id: z2.number(),
    entityId: z2.number()
  })
);
var getEntityTodoEpics = z2.object({
  type: entityType,
  entityId: z2.coerce.number()
});
var toggleType = z2.union([
  z2.literal("archive"),
  z2.literal("complete"),
  z2.literal("deadline")
]);
var toggle = z2.object({
  enabled: z2.enum(["true", "false"]).transform((value) => value === "true"),
  type: toggleType
});
var getTodoById = z2.object({
  id: z2.coerce.number()
}).merge(todoItemParams);
var getEntityTodoEpicById = getEntityTodoEpics.merge(
  z2.object({
    id: z2.coerce.number()
  })
);
var createTodoEpic = z2.object({
  title: z2.string().min(1).max(255),
  description: z2.string().max(3e3).optional().default(""),
  createdById: z2.number().optional(),
  due: z2.string().optional().nullable(),
  entityId: z2.number(),
  type: entityType,
  status: z2.union([
    z2.literal("archived"),
    z2.literal("completed"),
    z2.literal("todo"),
    z2.literal("in-progress")
  ])
});
var updateTodoEpic = z2.object({ id: z2.number() }).merge(createTodoEpic.partial());
var createTodoEpicResponse = z2.object({ id: z2.number() }).merge(createTodoEpic);
var createTodoList = z2.object({
  title: z2.string(),
  todoEpicId: z2.number()
});
var epicParams = z2.object({
  epicId: z2.coerce.number()
}).merge(ent);
var getTodoListById = z2.object({
  id: z2.coerce.number()
}).merge(epicParams);
var updateTodoList = z2.object({
  id: z2.number()
}).merge(createTodoList.partial());
var createComment = z2.object({
  comment: z2.string(),
  todoEpicId: z2.number(),
  memberId: z2.number().optional()
});
var getCommentById = z2.object({
  id: z2.coerce.number()
}).merge(epicParams);
var getAssignedMemberById = z2.object({
  id: z2.number()
});
var assignMember = z2.object({
  memberId: z2.number(),
  todoEpicId: z2.number()
});
var _a;
var createFullEpic = z2.object({
  name: z2.string(),
  description: z2.string(),
  assigned: z2.number().array(),
  entityType,
  entityId: z2.number(),
  due: (_a = z2.string()) == null ? void 0 : _a.optional().nullable(),
  status: z2.union([
    z2.literal("archived"),
    z2.literal("completed"),
    z2.literal("todo"),
    z2.literal("in-progress")
  ]),
  taskList: z2.object({
    name: z2.string(),
    tasks: z2.object({
      name: z2.string(),
      description: z2.string()
    }).array()
  }).array()
});
var statusUnion = z2.union([
  z2.literal("archived"),
  z2.literal("completed"),
  z2.literal("todo"),
  z2.literal("in-progress")
]);
var coerceNumberArray = z2.union([z2.coerce.number(), z2.array(z2.coerce.number())]).transform((v) => Array.isArray(v) ? v : [v]).optional();
var coerceStringArray = (item) => z2.union([item, z2.array(item)]).transform((v) => Array.isArray(v) ? v : [v]).optional();
var taskTableQuery = z2.object({
  entity: z2.object({
    id: z2.coerce.number(),
    entityType
  }).optional(),
  showAssigned: z2.enum(["true", "false"]).transform((value) => value === "true"),
  startDate: z2.string().optional(),
  endDate: z2.string().optional(),
  memberId: z2.coerce.number().optional(),
  entityTypes: coerceStringArray(entityType),
  statuses: coerceStringArray(statusUnion),
  assignedMemberIds: coerceNumberArray,
  createdByIds: coerceNumberArray,
  dueBefore: z2.string().optional(),
  dueAfter: z2.string().optional(),
  overdue: z2.enum(["true", "false"]).transform((v) => v === "true").optional(),
  unassigned: z2.enum(["true", "false"]).transform((v) => v === "true").optional()
}).merge(tableQuery);
var taskTableQueryOpts = z2.object({
  memberId: z2.coerce.number().optional(),
  brandingId: z2.coerce.number().optional(),
  showAssigned: z2.enum(["true", "false"]).transform((value) => value === "true"),
  access: z2.union([
    z2.literal("member"),
    z2.literal("brand_admin"),
    z2.literal("super_admin")
  ]).optional()
}).merge(taskTableQuery);

// src/lib/todos/types.ts
var types_exports = {};

// src/lib/todos/index.ts
var commonFunction = () => {
};
var todos = {
  schema: schema_exports,
  commonFunction
};

// src/lib/forecasting/schema.ts
var schema_exports2 = {};
__export(schema_exports2, {
  forecastingTableQuery: () => forecastingTableQuery
});
import z3 from "zod";
var forecastingTableQuery = z3.object({
  cbsa: z3.object({
    cbsa: z3.string()
  }),
  county: z3.object({
    county: z3.string()
  }).optional(),
  population: z3.object({
    value: z3.number(),
    symbol: z3.string()
  }).optional(),
  sort: z3.object({
    field: z3.union([
      z3.literal("population"),
      z3.literal("portalStatus"),
      z3.literal("suggestedleads"),
      z3.literal("advertisingConfidenceScore")
    ]),
    sort: z3.union([z3.literal("asc"), z3.literal("desc")])
  }),
  condition: z3.union([z3.literal("and"), z3.literal("or")]),
  filters: z3.array(
    z3.object({
      columnField: z3.union([z3.literal("and"), z3.literal("or")]),
      operatorValue: tableFilterExpression,
      value: z3.string()
    })
  )
}).merge(tableQuery);

// src/lib/forecasting/types.ts
var types_exports2 = {};

// src/lib/forecasting/index.ts
var forecasting = {
  schema: schema_exports2
};

// src/lib/scorecard/types.ts
var AGREEMENT_TYPES = ["bba", "listing", "cash_offer"];
function isAgreementType(x) {
  return AGREEMENT_TYPES.includes(x);
}

// src/lib/scorecard/registry.ts
var SCORECARD_EVENT_TYPES = [
  "CALL_CONNECTED",
  "CALL_NO_CONTACT",
  "CALL_BAD_NUMBER",
  "TEXT_SENT",
  "TEXT_REPLIED",
  "TEXT_UNDELIVERABLE",
  "EMAIL_SENT",
  "EMAIL_REPLIED",
  "EMAIL_BOUNCED",
  "APPT_SET",
  "APPT_MET",
  "APPT_NOSHOW",
  "AGREEMENT_SIGNED",
  "DEAL_CLOSED",
  "CONTACT_VERIFIED"
];
var isEventType = (x) => typeof x === "string" && SCORECARD_EVENT_TYPES.includes(x);
var FLAG_EVENT_TYPES = [
  "CALL_BAD_NUMBER",
  "TEXT_UNDELIVERABLE",
  "EMAIL_BOUNCED",
  "CONTACT_VERIFIED"
];
var isFlagEventType = (x) => typeof x === "string" && FLAG_EVENT_TYPES.includes(x);
var OUTREACH_CHANNEL_BY_TYPE = {
  CALL_CONNECTED: "call",
  CALL_NO_CONTACT: "call",
  TEXT_SENT: "text",
  EMAIL_SENT: "email"
};
var outreachChannelOf = (x) => {
  var _a2;
  if (!isEventType(x))
    return null;
  return (_a2 = OUTREACH_CHANNEL_BY_TYPE[x]) != null ? _a2 : null;
};

// src/lib/scorecard/reducer.ts
var initialFunnelState = () => ({
  needsReschedule: false,
  apptNoshowCount: 0
});
var toMillis = (isoTimestamp) => new Date(isoTimestamp).getTime();
var compareEvents = (a, b) => {
  const delta = toMillis(a.occurredAt) - toMillis(b.occurredAt);
  if (delta !== 0)
    return delta;
  if (typeof a.id === "number" && typeof b.id === "number")
    return a.id - b.id;
  const aId = String(a.id);
  const bId = String(b.id);
  return aId < bId ? -1 : aId > bId ? 1 : 0;
};
var laterOf = (current, candidate) => current !== void 0 && toMillis(current) >= toMillis(candidate) ? current : candidate;
var defaultWarn = (message, event) => (
  // eslint-disable-next-line no-console
  console.warn(message, { id: event.id, type: event.type })
);
function reduce(events, options) {
  var _a2;
  const warn = (_a2 = options == null ? void 0 : options.warn) != null ? _a2 : defaultWarn;
  const state = initialFunnelState();
  const ordered = events.slice().sort(compareEvents);
  for (const event of ordered) {
    if (event.deletedAt)
      continue;
    if (!isEventType(event.type)) {
      warn(
        `scorecard reduce: unknown event type "${event.type}" skipped`,
        event
      );
      continue;
    }
    applyEvent(state, event, event.type, warn);
  }
  return state;
}
function applyEvent(state, event, type, warn) {
  var _a2, _b;
  const t = event.occurredAt;
  switch (type) {
    case "CALL_BAD_NUMBER":
    case "TEXT_UNDELIVERABLE":
      if (state.badPhoneAt === void 0)
        state.badPhoneAt = t;
      return;
    case "EMAIL_BOUNCED":
      if (state.badEmailAt === void 0)
        state.badEmailAt = t;
      return;
    case "CONTACT_VERIFIED":
      if (((_a2 = event.data) == null ? void 0 : _a2.channel) === "phone")
        state.badPhoneAt = void 0;
      else
        state.badEmailAt = void 0;
      return;
    default:
      break;
  }
  if (type === "APPT_NOSHOW" && state.apptSetAt === void 0) {
    warn("scorecard reduce: APPT_NOSHOW without a prior APPT_SET ignored", event);
    return;
  }
  switch (type) {
    case "CALL_CONNECTED":
    case "TEXT_REPLIED":
    case "EMAIL_REPLIED":
      if (state.connectedAt === void 0)
        state.connectedAt = t;
      break;
    case "CALL_NO_CONTACT":
    case "TEXT_SENT":
    case "EMAIL_SENT":
      break;
    case "APPT_SET":
      if (state.connectedAt === void 0)
        state.connectedAt = t;
      if (state.apptSetAt === void 0)
        state.apptSetAt = t;
      state.lastApptSetAt = t;
      state.needsReschedule = false;
      break;
    case "APPT_NOSHOW":
      state.apptNoshowCount += 1;
      state.needsReschedule = true;
      break;
    case "APPT_MET":
      if (state.connectedAt === void 0)
        state.connectedAt = t;
      if (state.apptSetAt === void 0)
        state.apptSetAt = t;
      if (state.apptMetAt === void 0)
        state.apptMetAt = t;
      state.needsReschedule = false;
      break;
    case "AGREEMENT_SIGNED": {
      if (state.connectedAt === void 0)
        state.connectedAt = t;
      if (state.apptSetAt === void 0)
        state.apptSetAt = t;
      if (state.apptMetAt === void 0)
        state.apptMetAt = t;
      if (state.agreementAt === void 0)
        state.agreementAt = t;
      const agreementType = (_b = event.data) == null ? void 0 : _b.agreementType;
      if (isAgreementType(agreementType)) {
        if (state.agreementType === void 0)
          state.agreementType = agreementType;
      } else {
        warn(
          `scorecard reduce: AGREEMENT_SIGNED with invalid agreementType ${JSON.stringify(
            agreementType
          )}`,
          event
        );
      }
      break;
    }
    case "DEAL_CLOSED":
      if (state.connectedAt === void 0)
        state.connectedAt = t;
      if (state.apptSetAt === void 0)
        state.apptSetAt = t;
      if (state.apptMetAt === void 0)
        state.apptMetAt = t;
      if (state.agreementAt === void 0)
        state.agreementAt = t;
      if (state.closedAt === void 0)
        state.closedAt = t;
      break;
  }
  if (state.firstAttemptAt === void 0)
    state.firstAttemptAt = t;
  state.lastTouchAt = laterOf(state.lastTouchAt, event.createdAt);
}

// src/lib/scorecard/selectors.ts
var DAY_MS = 24 * 60 * 60 * 1e3;
function getStage(state) {
  if (state.closedAt)
    return "closed";
  if (state.agreementAt)
    return "agreement";
  if (state.apptMetAt)
    return "apptMet";
  if (state.apptSetAt)
    return "apptSet";
  if (state.connectedAt)
    return "connected";
  if (state.firstAttemptAt)
    return "working";
  return "new";
}
function getRings(state) {
  return {
    connected: state.connectedAt ? 1 : state.firstAttemptAt ? 0.25 : 0,
    appt: state.apptMetAt ? 1 : state.apptSetAt ? 0.5 : 0,
    agreement: state.agreementAt ? 1 : 0,
    closed: Boolean(state.closedAt)
  };
}
function isStale(state, sinceFallback, staleDays, now = /* @__PURE__ */ new Date()) {
  var _a2;
  if (state.closedAt || state.badPhoneAt || state.badEmailAt)
    return false;
  const reference = (_a2 = state.lastTouchAt) != null ? _a2 : sinceFallback;
  return new Date(reference).getTime() < now.getTime() - staleDays * DAY_MS;
}

// src/lib/scorecard/next-step.ts
function nextStep(state) {
  if (state.closedAt)
    return { key: "DONE", label: "\u{1F3C6} Deal won" };
  if (!state.connectedAt)
    return { key: "OUTREACH", label: "Log outreach" };
  if (!state.apptSetAt) {
    return { key: "SET_APPT", label: "\u{1F4C5} Set the appointment" };
  }
  if (state.apptSetAt && state.needsReschedule) {
    return { key: "SET_APPT", label: "\u{1F504} Reschedule" };
  }
  if (!state.apptMetAt) {
    return {
      key: "MARK_MET",
      label: "\u2713 Mark appointment met",
      alt: "No-show \u2192 reschedule"
    };
  }
  if (!state.agreementAt)
    return { key: "AGREEMENT", label: "\u{1F4DD} Log the agreement" };
  return { key: "CLOSE", label: "\u{1F3C1} Log the closing" };
}

// src/lib/scorecard/leaderboard.ts
var LEADERBOARD_WEIGHTS = {
  outcomes: 55,
  conversion: 25,
  coverage: 20,
  /**
   * Relative weight WITHIN the outcomes bucket. Closings dominate partly
   * because they are the point of the funnel and partly as an anti-gaming
   * measure: closings are cross-checkable against transactions, APPT_MET is
   * self-reported and unverifiable (§5.6).
   */
  outcomeSplit: { closings: 0.5, agreements: 0.3, apptsMet: 0.2 },
  /**
   * `k` in `1 - e^(-c/k)`. Chosen so the count in the comment earns ~90% of
   * its sub-bucket; tune at the data gate, but keep the CURVE.
   */
  saturation: {
    closings: 1.3,
    // ~3 closings
    agreements: 2.6,
    // ~6 agreements
    apptsMet: 5.2
    // ~12 appointments met
  },
  /** Prior weight `m` in (x + m·μ) / (n + m). Higher = thin samples regress harder. */
  shrinkage: 5,
  /** Points lost per stale lead, and the cap on that loss. */
  stalePenaltyPerLead: 1,
  stalePenaltyCap: 10,
  /** Volume tier boundaries, on leadsAssigned (§4.4). */
  tiers: { established: 6, developing: 2 }
};
var clamp01 = (n) => n < 0 ? 0 : n > 1 ? 1 : n;
function saturate(count2, k) {
  if (!(count2 > 0) || !(k > 0))
    return 0;
  return 1 - Math.exp(-count2 / k);
}
function shrinkRate(numerator, denominator, prior, m = LEADERBOARD_WEIGHTS.shrinkage) {
  const n = denominator > 0 ? denominator : 0;
  const x = numerator > 0 ? numerator : 0;
  return (x + m * prior) / (n + m);
}
function assignTier(volume) {
  if (!(volume > 0))
    return "unranked";
  if (volume >= LEADERBOARD_WEIGHTS.tiers.established)
    return "established";
  if (volume >= LEADERBOARD_WEIGHTS.tiers.developing)
    return "developing";
  return "single";
}
function volumeOf(stats) {
  return stats.leadsAssigned && stats.leadsAssigned > 0 ? stats.leadsAssigned : stats.leadsWorked;
}
function computeCohortPrior(rows) {
  const sum = (pick) => rows.reduce((acc, r) => acc + (pick(r) || 0), 0);
  const ratio = (num, den) => den > 0 ? num / den : 0;
  return {
    connectRate: ratio(sum((r) => r.connected), sum((r) => r.leadsWorked)),
    apptMetRate: ratio(sum((r) => r.apptsMet), sum((r) => r.apptsSet)),
    agreementRate: ratio(sum((r) => r.agreements), sum((r) => r.connected)),
    coverageRate: ratio(
      sum((r) => {
        var _a2;
        return (_a2 = r.leadsWorkedInWindow) != null ? _a2 : 0;
      }),
      sum((r) => {
        var _a2;
        return (_a2 = r.leadsAssigned) != null ? _a2 : 0;
      })
    )
  };
}
function scoreAgent(stats, prior, options) {
  var _a2, _b;
  const W = LEADERBOARD_WEIGHTS;
  const outcomesFraction = W.outcomeSplit.closings * saturate(stats.closings, W.saturation.closings) + W.outcomeSplit.agreements * saturate(stats.agreements, W.saturation.agreements) + W.outcomeSplit.apptsMet * saturate(stats.apptsMet, W.saturation.apptsMet);
  const rateContribution = (numerator, denominator, priorMean) => denominator > 0 ? clamp01(shrinkRate(numerator, denominator, priorMean)) : 0;
  const conversionFraction = (rateContribution(stats.connected, stats.leadsWorked, prior.connectRate) + rateContribution(stats.apptsMet, stats.apptsSet, prior.apptMetRate) + rateContribution(
    stats.agreements,
    stats.connected,
    prior.agreementRate
  )) / 3;
  const leadsAssigned = (_a2 = stats.leadsAssigned) != null ? _a2 : 0;
  const hasPool = leadsAssigned > 0;
  const coverageFraction = hasPool ? clamp01(((_b = stats.leadsWorkedInWindow) != null ? _b : 0) / leadsAssigned) : 0;
  const coverageCounts = options.coverageApplicable && hasPool;
  let outcomes = W.outcomes * outcomesFraction;
  let conversion = W.conversion * conversionFraction;
  let coverage = coverageCounts ? W.coverage * coverageFraction : 0;
  if (!coverageCounts) {
    const scale = 100 / (W.outcomes + W.conversion);
    outcomes *= scale;
    conversion *= scale;
    coverage = 0;
  }
  const hygiene = -Math.min(
    Math.max(stats.stale, 0) * W.stalePenaltyPerLead,
    W.stalePenaltyCap
  );
  const total = Math.max(
    0,
    Math.min(100, outcomes + conversion + coverage + hygiene)
  );
  return { total, outcomes, conversion, coverage, hygiene };
}
function hasActivity(stats) {
  return stats.leadsWorked > 0;
}
var TIER_ORDER = ["established", "developing", "single"];
var EPSILON = 1e-9;
function rankAgents(agents, prior, options) {
  const scored = agents.map((agent) => {
    const tier = assignTier(volumeOf(agent));
    return {
      agent,
      // With inactive agents deliberately included, someone with no volume
      // at all still belongs somewhere rather than vanishing — they sit in
      // the bottom bracket. Without that flag they are filtered out below.
      tier: tier === "unranked" && options.includeInactive ? "single" : tier,
      score: scoreAgent(agent, prior, options)
    };
  }).filter(
    (row) => row.tier !== "unranked"
  );
  const out = [];
  for (const tier of TIER_ORDER) {
    const inTier = scored.filter((row) => row.tier === tier).sort(
      (a, b) => {
        var _a2, _b;
        return b.score.total - a.score.total || b.agent.closings - a.agent.closings || b.agent.agreements - a.agent.agreements || b.agent.apptsMet - a.agent.apptsMet || ((_a2 = b.agent.coverageRate) != null ? _a2 : 0) - ((_b = a.agent.coverageRate) != null ? _b : 0) || a.agent.memberName.localeCompare(b.agent.memberName) || a.agent.memberId - b.agent.memberId;
      }
    );
    let rank = 0;
    inTier.forEach((row, index) => {
      const prev = inTier[index - 1];
      const tied = prev !== void 0 && Math.abs(prev.score.total - row.score.total) < EPSILON;
      rank = tied ? rank : index + 1;
      out.push(__spreadProps(__spreadValues({}, row.agent), { score: row.score, tier, rank }));
    });
  }
  return out;
}
function buildLeaderboard(agents, options) {
  const population = options.includeInactive ? agents : agents.filter(hasActivity);
  const prior = computeCohortPrior(population);
  return {
    board: rankAgents(population, prior, options),
    prior,
    excluded: agents.length - population.length
  };
}
var FEATURED = { min: 4, floor: 3, cap: 10, quantile: 4 };
function featuredCount(rankedCount) {
  if (!(rankedCount >= FEATURED.min))
    return 0;
  return Math.min(
    FEATURED.cap,
    Math.max(FEATURED.floor, Math.ceil(rankedCount / FEATURED.quantile))
  );
}
function computeRankDelta(current, previous) {
  const before = previous.find((p) => p.memberId === current.memberId);
  if (!before)
    return { rankDelta: null, isNew: true, tierChanged: false };
  if (before.tier !== current.tier) {
    return { rankDelta: null, isNew: false, tierChanged: true };
  }
  return {
    rankDelta: before.rank - current.rank,
    isNew: false,
    tierChanged: false
  };
}

// src/lib/scorecard/cohorts.ts
var COHORT_ID = /^[1-9][0-9]{0,14}$/;
var DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
var MODES = ["all", "none", "brand"];
var count = (n) => n.toLocaleString("en-US");
var hasCohorts = (list) => !!list && list.cohorts.length > 0;
function buildCohortOptions(list) {
  if (!hasCohorts(list))
    return [];
  return [
    { value: "all", label: "All cohorts" },
    ...list.cohorts.map((cohort) => ({
      value: String(cohort.id),
      label: `${cohort.name} \xB7 ${cohort.startsOn} \xB7 ${count(
        cohort.activeMembers
      )} active`
    })),
    { value: "none", label: `Not in a cohort (${count(list.unassigned)})` },
    { value: "brand", label: "Whole brand" }
  ];
}
function resolveCohortParam(queryValue, list) {
  if (!hasCohorts(list))
    return void 0;
  const value = Array.isArray(queryValue) ? queryValue[0] : queryValue;
  if (!value)
    return "all";
  if (MODES.includes(value))
    return value;
  if (COHORT_ID.test(value) && list.cohorts.some((c) => String(c.id) === value)) {
    return value;
  }
  return "all";
}
function findSelectedCohort(param, list) {
  var _a2;
  if (!param || !list || !COHORT_ID.test(param))
    return null;
  return (_a2 = list.cohorts.find((c) => String(c.id) === param)) != null ? _a2 : null;
}
var parseLocalDay = (value) => {
  const match = DATE_ONLY.exec(value);
  if (!match)
    return null;
  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(year, month - 1, day, 0, 0, 0, 0);
  const sameDay = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  return sameDay ? date : null;
};
function sinceCohortStartPreset(startsOn, now) {
  const startDate = parseLocalDay(startsOn);
  if (!startDate)
    return null;
  const endDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999
  );
  if (startDate.getTime() > endDate.getTime())
    return null;
  return { label: "Since cohort start", startDate, endDate };
}
function cohortPopulationLabel(label) {
  if (!label)
    return "Whole brand";
  if (label.mode === "all")
    return "All cohorts";
  if (label.mode === "none")
    return "Not in a cohort";
  return `${label.name} \xB7 starts ${label.startsOn}`;
}
function scorecardExportFilename(brandId, cohort, from, to) {
  return `scorecard-${brandId}-${cohort != null ? cohort : "brand"}-${from}-${to}.csv`;
}
function withCohortParam(params, cohort) {
  return cohort === void 0 ? params : __spreadProps(__spreadValues({}, params), { cohort });
}

// src/lib/scorecard/cohort-management.ts
var MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function cohortErrorMessage(status, serverMessage) {
  switch (status) {
    case 409:
      return serverMessage || "A cohort with this name already exists for this brand.";
    case 422:
      return serverMessage || "Some of these agents are not currently members of this brand.";
    case 400:
      return serverMessage || "Check the name and the start date.";
    case 404:
      return "This cohort no longer exists. Refresh the page.";
    default:
      return "The change could not be saved. Please try again.";
  }
}
function defaultTargetCohortId(group, cohorts) {
  var _a2, _b;
  if (group.suggestedCohortId !== null && cohorts.some((c) => c.id === group.suggestedCohortId)) {
    return group.suggestedCohortId;
  }
  return (_b = (_a2 = cohorts[0]) == null ? void 0 : _a2.id) != null ? _b : null;
}
function newCohortDraft(group) {
  var _a2;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec((_a2 = group.arrivalDay) != null ? _a2 : "");
  if (!match)
    return { name: "", startsOn: "" };
  const [year, month, day] = match.slice(1).map(Number);
  const monthName = MONTHS[month - 1];
  if (!monthName)
    return { name: "", startsOn: "" };
  return { name: `${monthName} ${day} ${year}`, startsOn: group.arrivalDay };
}
function assignedOnRange(group) {
  const days = group.members.map((m) => {
    var _a2;
    return (_a2 = m.assignedOn) == null ? void 0 : _a2.slice(0, 10);
  }).filter((d) => !!d).sort();
  if (days.length === 0)
    return "\u2014";
  const first = days[0];
  const last = days[days.length - 1];
  return first === last ? first : `${first} \u2013 ${last}`;
}
function selectedMemberIds(group, unchecked) {
  return group.members.filter((m) => !unchecked.has(m.id)).map((m) => m.id);
}
var REJECTED_SHOWN = 10;
function rejectedMembersMessage(memberIds, known) {
  const byId = new Map(known.map((m) => [m.id, m]));
  const label = (id) => {
    const member = byId.get(id);
    if (!member)
      return `member #${id}`;
    if (member.name && member.email)
      return `${member.name} (${member.email})`;
    return member.name || member.email || `member #${id}`;
  };
  const shown = memberIds.slice(0, REJECTED_SHOWN).map(label);
  const more = memberIds.length - shown.length;
  return `Not currently members of this brand (they may have left it since this list loaded): ${shown.join(
    ", "
  )}${more > 0 ? `, and ${more} more` : ""}.`;
}

// src/constants/activity-map.ts
var activities = {
  "showing-request": "Showing Request",
  "store-saved-property": "Property Save",
  "delete-saved-property": "Property Delete",
  "viewed-property": "Property View",
  "store-user-inquiry": "Inquiry",
  "store-saved-search": "Saved Search",
  "delete-saved-search": "Saved Search Delete",
  "store-lead-note": "Note Added",
  "stage-change": "Stage Change",
  registration: "Registration",
  "store-lead-note-comment": "Comment Added",
  "delete-lead-note": "Note Deleted",
  "delete-lead-note-comment": "Comment Deleted",
  "update-user-details": "User Details Updated",
  "agent-direct": "Agent Direct",
  "social-share": "Social Share",
  "email-share": "Email Share",
  "reassign-lead": "Lead Reassigned",
  "mortgage-calc": "Mortgage Calculator",
  "homeward-prelim": "Homeward Preliminary Report Generated",
  "tcpa-set": "TCPA Set"
};

// src/constants/sales/stage-map.ts
var stageMap = {
  started: {
    label: "Started",
    value: "started",
    color: "info.main",
    category: "neutral"
  },
  pending_sign: {
    label: "Pending Sign",
    value: "pending_sign",
    color: "info.main",
    category: "neutral"
  },
  signed: {
    label: "Signed",
    value: "signed",
    color: "error.main",
    category: "neutral"
  },
  paid: {
    label: "Paid",
    value: "paid",
    color: "error.main",
    category: "neutral"
  },
  paid_signed: {
    label: "Paid and Signed",
    value: "paid_signed",
    color: "error.main",
    category: "neutral"
  },
  pending_questionnaire: {
    label: "Pending Questionnaire",
    value: "pending_questionnaire",
    color: "error.main",
    category: "neutral"
  },
  idx_review: {
    label: "IDX / Review",
    value: "idx_review",
    color: "error.main",
    category: "neutral"
  },
  onboarding: {
    label: "Onboarding",
    value: "onboarding",
    color: "warning.main",
    category: "neutral"
  },
  completed: {
    label: "Complete",
    value: "completed",
    color: "success.main",
    category: "won"
  },
  collections: {
    label: "Collections",
    value: "collections",
    color: "warning.main",
    category: "neutral"
  },
  cancelled: {
    label: "Cancelled",
    value: "cancelled",
    color: "warning.main",
    category: "lost"
  },
  dead_deal: {
    label: "Dead Deal",
    value: "dead_deal",
    color: "warning.main",
    category: "lost"
  },
  pending_cancellation: {
    label: "Pending Cancellation",
    value: "pending_cancellation",
    color: "warning.main",
    category: "lost"
  },
  crm_support: {
    label: "CRM Support",
    value: "crm_support",
    color: "warning.main",
    category: "lost"
  },
  idx_hold: {
    label: "IDX Hold",
    value: "idx_hold",
    color: "warning.main",
    category: "lost"
  }
};
var stageOptions = Object.values(stageMap).map((stage) => ({
  color: stage.color,
  label: stage.label,
  value: stage.value
}));

// src/constants/notifications-map.ts
var inquiryFields = [
  "AVM_CLAIM",
  "BUYER_LEAD",
  "BUYING_TIPS",
  "AGENT_DIRECT",
  "SELLING_TIPS",
  "AVM_SELLER_LEAD",
  "DEFAULT_INQUIRY",
  "CASH_SELLER_LEAD",
  "EARLY_SELLER_LEAD",
  "REALTY_EARLY_SELLER",
  "CS_BUYER_SELLER_LEAD",
  "LEAD_MORTGAGE_CALC",
  "LOAN_REQUEST"
];
var propertyFields = [
  "LEAD_SAVED_SEARCH",
  "PROPERTY_INQUIRY",
  "LEAD_SAVED_PROPERTY"
];
var leadFields = [
  "LEAD_STATUS_UPDATE",
  "LEAD_TOUR_SCHEDULE",
  "LEAD_CALLBACK",
  "LEAD_CREATED",
  "LEAD_UPDATED",
  "LEAD_ATTEMPTED_TRANSFER",
  "LEAD_WARM_TRANSFER",
  "LEAD_FRENZY_CLAIM",
  "LEAD_HOMEWARD_PRELIMINARY_REPORT",
  "CAMPAIGN_CLICK"
];
var notesFields = [
  "NOTES_CREATED",
  "NOTES_DELETED",
  "NOTES_COMMENTED",
  "NOTES_COMMENT_DELETED"
];
var fieldDescription = {
  LEAD_MORTGAGE_CALC: {
    title: "Lead Mortgage Calculator",
    description: "Receive alerts when a lead interacts with the mortgage calculator."
  },
  AVM_CLAIM: {
    title: "AVM Claim",
    description: "Receive alerts when a homeowner claims a property and registers an account."
  },
  BUYER_LEAD: {
    title: "Buyer Lead",
    description: "Receive alerts when a new buyer lead registers."
  },
  BUYING_TIPS: {
    title: "Buying Tips",
    description: "Receive alerts when a buyer lead registers on buying tips page."
  },
  AGENT_DIRECT: {
    title: "Agent Direct",
    description: "Receive alerts when a lead submits the email agent / contact agent form."
  },
  LEAD_CREATED: {
    title: "Lead Created",
    description: "Receive alerts when a new lead is created."
  },
  LEAD_UPDATED: {
    title: "Lead Updated",
    description: "Receive notifications when a lead contact information is updated."
  },
  SELLING_TIPS: {
    title: "Selling Tips",
    description: "Receive alerts when a buyer lead registers on selling tips page."
  },
  LEAD_CALLBACK: {
    title: "Lead Callback",
    description: "Receive a notification when a lead requests a call back."
  },
  NOTES_CREATED: {
    title: "Notes Created",
    description: "Receive notifications when a note is added to a lead."
  },
  NOTES_DELETED: {
    title: "Notes Deleted",
    description: "Receive notifications when a note is deleted."
  },
  AVM_SELLER_LEAD: {
    title: "AVM Seller Lead",
    description: 'Receive alert when a seller fills out the "I want to sell" home valuation form.'
  },
  DEFAULT_INQUIRY: {
    title: "Default Inquiry",
    description: "Important notification about something"
  },
  NOTES_COMMENTED: {
    title: "Notes Commented",
    description: "Receive notifications when a comment is added."
  },
  CASH_SELLER_LEAD: {
    title: "Cash Seller Lead",
    description: "Receive a notification when a new seller lead requests a cash offer with a more immediate timeframe to sell."
  },
  PROPERTY_INQUIRY: {
    title: "Property Inquiry",
    description: "Receive alerts when a lead has submitted a property inquiry on a property."
  },
  EARLY_SELLER_LEAD: {
    title: "Early Seller Lead",
    description: "Receive a notification when a new seller lead requests a cash offer with a specified timeframe to sell."
  },
  LOAN_REQUEST: {
    title: "Loan Request",
    description: "Receive a notification on loan request inquiry."
  },
  LEAD_SAVED_SEARCH: {
    title: "Lead Saved Search",
    description: "Receive alerts when a lead has saved a property search."
  },
  LEAD_STATUS_UPDATE: {
    title: "Lead Status Update",
    description: "Receive a notification when a lead\u2019s status is updated."
  },
  LEAD_TOUR_SCHEDULE: {
    title: "Lead Tour Schedule",
    description: "Receive a notification when a lead requests to view a property."
  },
  NOTIFICATION_SOUND: {
    title: "Notification Sound",
    description: "Important notification about something"
  },
  LEAD_SAVED_PROPERTY: {
    title: "Lead Saved Property",
    description: "Receive alerts when a lead has saved a new property."
  },
  REALTY_EARLY_SELLER: {
    title: "Realty Early Seller",
    description: "Important notification about something"
  },
  CS_BUYER_SELLER_LEAD: {
    title: "CS Buyer Seller Lead",
    description: "Important notification about something"
  },
  NOTES_COMMENT_DELETED: {
    title: "Notes Comment Deleted",
    description: "Receive notifications when a comment is deleted."
  },
  LEAD_ATTEMPTED_TRANSFER: {
    title: "Lead Attempted Transfer",
    description: "Receive notifications when a lead is attempted to transfer."
  },
  LEAD_WARM_TRANSFER: {
    title: "Lead Warm Transfer",
    description: "Receive notifications when a lead is warm transferred."
  },
  LEAD_FRENZY_CLAIM: {
    title: "Lead Frenzy Claim",
    description: "Receive notifications when there is a lead to claim near me from the Frenzy pool."
  },
  LEAD_HOMEWARD_PRELIMINARY_REPORT: {
    title: "Lead Homeward Preliminary Report",
    description: "Receive notifications when a Homeward Preliminary Report is generated."
  },
  CAMPAIGN_CLICK: {
    title: "Campaign Click",
    description: "Receive notifications when a Home value or Market area report is clicked."
  }
};
var initialNotificationValues = {
  lct: {
    types: Object.keys(fieldDescription).reduce(
      (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: false }),
      {}
    ),
    enabled: false
  },
  email: {
    disableOwnerMeta: false,
    types: Object.keys(fieldDescription).reduce(
      (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: false }),
      {}
    ),
    enabled: false
  },
  phone: {
    types: Object.keys(fieldDescription).reduce(
      (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: false }),
      {}
    ),
    enabled: false
  },
  app: {
    types: Object.keys(fieldDescription).reduce(
      (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: false }),
      {}
    )
  }
};
export {
  AGREEMENT_TYPES,
  DEFAULT_CONFIG,
  FEATURED,
  FLAG_EVENT_TYPES,
  types_exports2 as ForecastingTypes,
  LEADERBOARD_WEIGHTS,
  OUTREACH_CHANNEL_BY_TYPE,
  PREDEFINED_PROFILES,
  SCOPE_CATALOG,
  SCORECARD_EVENT_TYPES,
  SocialLinks,
  TYPE_DEFAULT,
  TYPE_DESKTOP,
  TYPE_MOBILE,
  types_exports as TodoTypes,
  activities,
  assignTier,
  assignedOnRange,
  buildCohortOptions,
  buildLeaderboard,
  cohortErrorMessage,
  cohortPopulationLabel,
  computeCohortPrior,
  computeRankDelta,
  defaultTargetCohortId,
  featuredCount,
  fieldDescription,
  findSelectedCohort,
  forecasting,
  generateValueUrl,
  generateValueUrlFromPlacekeyData,
  generateValueUrlFromValidatedAddress,
  getPriceBasedOnPopulation,
  getRings,
  getStage,
  hasActivity,
  initialFunnelState,
  initialNotificationValues,
  inquiryFields,
  isAgreementType,
  isEventType,
  isFlagEventType,
  isKnownScope,
  isStale,
  leadFields,
  newCohortDraft,
  nextStep,
  notesFields,
  outreachChannelOf,
  parseMessageForMention,
  propertyFields,
  rankAgents,
  reduce,
  rejectedMembersMessage,
  resolveCohortParam,
  saturate,
  scope,
  scoreAgent,
  scorecardExportFilename,
  selectedMemberIds,
  shrinkRate,
  sinceCohortStartPreset,
  stageMap,
  stageOptions,
  toLonLat,
  todos,
  volumeOf,
  withCohortParam
};
